import { useCallback, useEffect, useRef, useState } from 'react';

const allowedChars = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '.',
  '-',
  '+',
  'e',
  'E',
];

export default function NumberInput({
  value,
  onChange,
  onEnter,
}: {
  value: number | undefined | null;
  onChange: (value: number | undefined) => void;
  onEnter?: () => void;
}) {
  const [ogValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!inputRef.current) return;
    const txt = String(value ?? '');
    if (inputRef.current.textContent === txt) return;
    inputRef.current.textContent = txt;
  }, [value]);

  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (
        e.key === 'Enter' &&
        !(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) &&
        onEnter
      ) {
        e.preventDefault();
        onEnter();
        return;
      }
      if (
        allowedChars.includes(e.key) ||
        e.key.length > 1 ||
        e.altKey ||
        e.ctrlKey ||
        e.metaKey
      )
        return;
      e.preventDefault();
    },
    [onEnter],
  );

  return (
    <div
      className="px-2 py-1 text-left"
      contentEditable="plaintext-only"
      suppressContentEditableWarning={true}
      onKeyDown={onKeyDown}
      onInput={e => {
        const txt = e.currentTarget.textContent || '';
        if (txt.length === 0) {
          onChange(undefined);
          return;
        }
        const num = Number(txt);
        if (Number.isNaN(num)) return;
        onChange(num);
      }}
      onBlur={e => {
        if (!inputRef.current) return;
        const txt = String(value ?? '');
        if (inputRef.current.textContent === txt) return;
        inputRef.current.textContent = txt;
      }}
      ref={inputRef}
    >
      {ogValue}
    </div>
  );
}
